// @ vendor
const React = require('react');
// @ commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
// @ helpers
const { FormattedText } = require('core/i18n').i18n;

export default function TppKeyConsentHistoryTableHeader() {
    return (
        <OKTableRow asHeader={true}>
            <OKTableCell asHeader={true}>
                <FormattedText value="keysTppView-consentReceptionDateColumnHeader" />
            </OKTableCell>
            <OKTableCell asHeader={true}>
                <FormattedText value="keysTppView-consentTypeColumnHeader" />
            </OKTableCell>
            <OKTableCell asHeader={true}>
                <FormattedText value="keysTppView-consentStateColumnHeader" />
            </OKTableCell>
        </OKTableRow>
    );
}
